import React, { CSSProperties } from 'react'
import { ReactComponent as AlignHBaselineIcon } from './icons-roboten/align_h_baseline.svg'
import { ReactComponent as AlignHCenterIcon } from './icons-roboten/align_h_center.svg'
import { ReactComponent as AlignHEndIcon } from './icons-roboten/align_h_end.svg'
import { ReactComponent as AlignHStartIcon } from './icons-roboten/align_h_start.svg'
import { ReactComponent as AlignHStretchIcon } from './icons-roboten/align_h_stretch.svg'
import { ReactComponent as AlignVCenterIcon } from './icons-roboten/align_v_center.svg'
import { ReactComponent as AlignVEndIcon } from './icons-roboten/align_v_end.svg'
import { ReactComponent as AlignVStartIcon } from './icons-roboten/align_v_start.svg'
import { ReactComponent as AlignVStretchIcon } from './icons-roboten/align_v_stretch.svg'
import { ReactComponent as ApplicationIcon } from './icons-roboten/Application.svg'
import { ReactComponent as BgPosBottomCenterIcon } from './icons-roboten/bgPosBottomCenter.svg'
import { ReactComponent as BgPosBottomLeftIcon } from './icons-roboten/bgPosBottomLeft.svg'
import { ReactComponent as BgPosBottomRightIcon } from './icons-roboten/bgPosBottomRight.svg'
import { ReactComponent as BgPosCenterCenterIcon } from './icons-roboten/bgPosCenterCenter.svg'
import { ReactComponent as BgPosCenterLeftIcon } from './icons-roboten/bgPosCenterLeft.svg'
import { ReactComponent as BgPosCenterRightIcon } from './icons-roboten/bgPosCenterRight.svg'
import { ReactComponent as BgPosTopCenterIcon } from './icons-roboten/bgPosTopCenter.svg'
import { ReactComponent as BgPosTopLeftIcon } from './icons-roboten/bgPosTopLeft.svg'
import { ReactComponent as BgPosTopRightIcon } from './icons-roboten/bgPosTopRight.svg'
import { ReactComponent as ClearBothIcon } from './icons-roboten/clear_both.svg'
import { ReactComponent as ClearLeftIcon } from './icons-roboten/clear_left.svg'
import { ReactComponent as ClearRightIcon } from './icons-roboten/clear_right.svg'
import { ReactComponent as CloudUploadIcon } from './icons-roboten/CloudUpload.svg'
import { ReactComponent as ComponentIcon } from './icons-roboten/Component.svg'
import { ReactComponent as Connection16Icon } from './icons-roboten/Connection-16.svg'
import { ReactComponent as ConnectionIcon } from './icons-roboten/Connection.svg'
import { ReactComponent as CornerBottomLeftIcon } from './icons-roboten/corner_bottom_left.svg'
import { ReactComponent as CornerBottomRightIcon } from './icons-roboten/corner_bottom_right.svg'
import { ReactComponent as CornerTopLeftIcon } from './icons-roboten/corner_top_left.svg'
import { ReactComponent as CornerTopRightIcon } from './icons-roboten/corner_top_right.svg'
import { ReactComponent as DisplayBlockIcon } from './icons-roboten/display_block.svg'
import { ReactComponent as DisplayFlexIcon } from './icons-roboten/display_flex.svg'
import { ReactComponent as DisplayInlineIcon } from './icons-roboten/display_inline.svg'
import { ReactComponent as DisplayInlineBlockIcon } from './icons-roboten/display_inline_block.svg'
import { ReactComponent as ExperimentalIcon } from './icons-roboten/Experimental.svg'
import { ReactComponent as FileDocIcon } from './icons-roboten/file_doc.svg'
import { ReactComponent as FloatLeftIcon } from './icons-roboten/float_left.svg'
import { ReactComponent as FloatRightIcon } from './icons-roboten/float_right.svg'
import { ReactComponent as Folder16Icon } from './icons-roboten/Folder-16.svg'
import { ReactComponent as FolderIcon } from './icons-roboten/Folder.svg'
import { ReactComponent as FontSizeIcon } from './icons-roboten/font_size.svg'
import { ReactComponent as Formula16Icon } from './icons-roboten/Formula-16.svg'
import { ReactComponent as GapHIcon } from './icons-roboten/gap_h.svg'
import { ReactComponent as GapVIcon } from './icons-roboten/gap_v.svg'
import { ReactComponent as GrowIcon } from './icons-roboten/Grow.svg'
import { ReactComponent as HeightIcon } from './icons-roboten/height.svg'
import { ReactComponent as JSONObjectIcon } from './icons-roboten/JSONObject.svg'
import { ReactComponent as JustifyHCenterIcon } from './icons-roboten/justify_h_center.svg'
import { ReactComponent as JustifyHEndIcon } from './icons-roboten/justify_h_end.svg'
import { ReactComponent as JustifyHEvenlyIcon } from './icons-roboten/justify_h_evenly.svg'
import { ReactComponent as JustifyHSpaceAroundIcon } from './icons-roboten/justify_h_space_around.svg'
import { ReactComponent as JustifyHSpaceBetweenIcon } from './icons-roboten/justify_h_space_between.svg'
import { ReactComponent as JustifyHStartIcon } from './icons-roboten/justify_h_start.svg'
import { ReactComponent as JustifyVCenterIcon } from './icons-roboten/justify_v_center.svg'
import { ReactComponent as JustifyVEndIcon } from './icons-roboten/justify_v_end.svg'
import { ReactComponent as JustifyVEvenlyIcon } from './icons-roboten/justify_v_evenly.svg'
import { ReactComponent as JustifyVSpaceAroundIcon } from './icons-roboten/justify_v_space_around.svg'
import { ReactComponent as JustifyVSpaceBetweenIcon } from './icons-roboten/justify_v_space_between.svg'
import { ReactComponent as JustifyVStartIcon } from './icons-roboten/justify_v_start.svg'
import { ReactComponent as LibraryIcon } from './icons-roboten/Library.svg'
import { ReactComponent as LineHeightIcon } from './icons-roboten/line_height.svg'
import { ReactComponent as LockedIcon } from './icons-roboten/locked.svg'
import { ReactComponent as MasterViewIcon } from './icons-roboten/MasterView.svg'
import { ReactComponent as PreviewViewIcon } from './icons-roboten/PreviewView.svg'
import { ReactComponent as QueriesIcon } from './icons-roboten/Queries.svg'
import { ReactComponent as Query16Icon } from './icons-roboten/Query-16.svg'
import { ReactComponent as QueryIcon } from './icons-roboten/Query.svg'
import { ReactComponent as RepeatH } from './icons-roboten/repeat_h.svg'
import { ReactComponent as RepeatNone } from './icons-roboten/repeat_none.svg'
import { ReactComponent as RepeatV } from './icons-roboten/repeat_v.svg'
import { ReactComponent as RepeatVH } from './icons-roboten/repeat_vh.svg'
import { ReactComponent as RobotenRobotIcon } from './icons-roboten/Roboten.svg'
import { ReactComponent as ShrinkIcon } from './icons-roboten/Shrink.svg'
import { ReactComponent as SideAllIcon } from './icons-roboten/SideAll.svg'
import { ReactComponent as SideBottomIcon } from './icons-roboten/SideBottom.svg'
import { ReactComponent as SideLeftIcon } from './icons-roboten/SideLeft.svg'
import { ReactComponent as SideRightIcon } from './icons-roboten/SideRight.svg'
import { ReactComponent as SideTopIcon } from './icons-roboten/SideTop.svg'
import { ReactComponent as Slot16Icon } from './icons-roboten/Slot-16.svg'
import { ReactComponent as TextTransformCapitalizeIcon } from './icons-roboten/text_transform_capitalize.svg'
import { ReactComponent as TextTransformLowercaseIcon } from './icons-roboten/text_transform_lowercase.svg'
import { ReactComponent as TextTransformUppercaseIcon } from './icons-roboten/text_transform_uppercase.svg'
import { ReactComponent as UnlockedIcon } from './icons-roboten/unlocked.svg'
import { ReactComponent as VectorIcon } from './icons-roboten/vector.svg'
import { ReactComponent as ViewIcon } from './icons-roboten/View.svg'
import { ReactComponent as ViewsIcon } from './icons-roboten/Views.svg'
import { ReactComponent as WidthIcon } from './icons-roboten/width.svg'

import { ReactComponent as AppFolderIcon } from './icons-vkui/app_folder.svg'
import { ReactComponent as AppsIcon } from './icons-vkui/apps.svg'
import { ReactComponent as AssigmentIndIcon } from './icons-vkui/assigment_ind.svg'
import { ReactComponent as BoxUpIcon } from './icons-vkui/box_up.svg'
import { ReactComponent as BusinessIcon } from './icons-vkui/business.svg'
import { ReactComponent as CloudIcon } from './icons-vkui/cloud.svg'
import { ReactComponent as ContentCopyIcon } from './icons-vkui/content_copy.svg'
import { ReactComponent as DeleteIcon } from './icons-vkui/delete.svg'
import { ReactComponent as DownloadIcon } from './icons-vkui/download.svg'
import { ReactComponent as FileUploadIcon } from './icons-vkui/file_upload.svg'
import { ReactComponent as VKUIFolderIcon } from './icons-vkui/folder.svg'
import { ReactComponent as GppBadIcon } from './icons-vkui/gpp_bad.svg'
import { ReactComponent as GridViewIcon } from './icons-vkui/grid_view.svg'
import { ReactComponent as GroupsIcon } from './icons-vkui/groups.svg'
import { ReactComponent as HelpIcon } from './icons-vkui/help.svg'
import { ReactComponent as HistoryIcon } from './icons-vkui/history.svg'
import { ReactComponent as HowToRegIcon } from './icons-vkui/how_to_reg.svg'
import { ReactComponent as IcEmailIcon } from './icons-vkui/ic_email.svg'
import { ReactComponent as InfoIcon } from './icons-vkui/info.svg'
import { ReactComponent as ListIcon } from './icons-vkui/list.svg'
import { ReactComponent as LockIcon } from './icons-vkui/lock.svg'
import { ReactComponent as LoginIcon } from './icons-vkui/login.svg'
import { ReactComponent as LogoutIcon } from './icons-vkui/logout.svg'
import { ReactComponent as ModeEditIcon } from './icons-vkui/mode_edit.svg'
import { ReactComponent as NotificationsIcon } from './icons-vkui/notifications.svg'
import { ReactComponent as OpenWithIcon } from './icons-vkui/open_with.svg'
import { ReactComponent as PeopleIcon } from './icons-vkui/people.svg'
import { ReactComponent as PersonIcon } from './icons-vkui/person.svg'
import { ReactComponent as PersonAddIcon } from './icons-vkui/person_add.svg'
import { ReactComponent as PhoneIphoneIcon } from './icons-vkui/phone_iphone.svg'
import { ReactComponent as SearchIcon } from './icons-vkui/search.svg'
import { ReactComponent as StarOutlineIcon } from './icons-vkui/star_outline.svg'
import { ReactComponent as StorageIcon } from './icons-vkui/storage.svg'
import { ReactComponent as StoreIcon } from './icons-vkui/store.svg'
import { ReactComponent as TuneIcon } from './icons-vkui/tune.svg'
import { ReactComponent as VisibilityIcon } from './icons-vkui/visibility.svg'
import { ReactComponent as VisibilityOffIcon } from './icons-vkui/visibility_off.svg'
import { ReactComponent as VpnKeyIcon } from './icons-vkui/vpn_key.svg'
import { ReactComponent as WarningIcon } from './icons-vkui/warning.svg'
import { ReactComponent as WatchLaterIcon } from './icons-vkui/watch_later.svg'
import { ReactComponent as DoneIcon } from './icons-vkui/done.svg'
import { ReactComponent as ImageIcon } from './icons-vkui/image.svg'
import { ReactComponent as LinkIcon } from './icons-vkui/link.svg'
import { ReactComponent as LockOpenIcon } from './icons-vkui/lock_open.svg'

import { Icon as MaterialIcon } from '../Icon'
import { CssStyles, IconName, NamedSize } from '../../types'
import { getClassName, namedSizeToNumber, parseClassNames } from '../../utils'
import { cx } from '@emotion/css'
import { styled } from '@mui/material'

const UnavailableIcon: React.FC = () => (
  <div
    style={{
      height: 16,
      width: 16,
      background: 'yellow',
      fontSize: 12,
    }}
  >
    🚫
  </div>
)

const RobotenIconWrapper = styled('span', { name: 'RobotenIconWrapper' })<{
  size?: number
}>(({ size }) => ({
  display: 'inline-block',
  lineHeight: `${size}px`,
  width: size,
  height: size,
}))

export const robotenIcons = {
  // Roboten
  application: ApplicationIcon,
  cloudupload: CloudUploadIcon,
  component: ComponentIcon,
  connection16: Connection16Icon,
  connection: ConnectionIcon,
  displayinline: DisplayInlineIcon,
  displayflex: DisplayFlexIcon,
  displayinlineblock: DisplayInlineBlockIcon,
  displayblock: DisplayBlockIcon,
  folder: FolderIcon,
  folder16: Folder16Icon,
  formula16: Formula16Icon,
  jsonobject: JSONObjectIcon,
  masterview: MasterViewIcon,
  query16: Query16Icon,
  query: QueryIcon,
  queries: QueriesIcon,
  slot16: Slot16Icon,
  view: ViewIcon,
  views: ViewsIcon,
  sideall: SideAllIcon,
  sidebottom: SideBottomIcon,
  sideleft: SideLeftIcon,
  sideright: SideRightIcon,
  sidetop: SideTopIcon,
  library: LibraryIcon,
  robotenrobot: RobotenRobotIcon,
  experimental: ExperimentalIcon,
  alignhcenter: AlignHCenterIcon,
  alignhend: AlignHEndIcon,
  alignhstart: AlignHStartIcon,
  alignhstretch: AlignHStretchIcon,
  alignvcenter: AlignVCenterIcon,
  alignvend: AlignVEndIcon,
  alignvstart: AlignVStartIcon,
  alignvstretch: AlignVStretchIcon,
  justifyhcenter: JustifyHCenterIcon,
  justifyhend: JustifyHEndIcon,
  justifyhevenly: JustifyHEvenlyIcon,
  justifyhspacearound: JustifyHSpaceAroundIcon,
  justifyhstart: JustifyHStartIcon,
  justifyvcenter: JustifyVCenterIcon,
  justifyvend: JustifyVEndIcon,
  justifyvevenly: JustifyVEvenlyIcon,
  justifyvspacearound: JustifyVSpaceAroundIcon,
  justifyvstart: JustifyVStartIcon,
  alignhbaseline: AlignHBaselineIcon,
  justifyvspacebetween: JustifyVSpaceBetweenIcon,
  justifyhspacebetween: JustifyHSpaceBetweenIcon,
  gaph: GapHIcon,
  gapv: GapVIcon,
  grow: GrowIcon,
  shrink: ShrinkIcon,
  locked: LockedIcon,
  unlocked: UnlockedIcon,
  cornerbottomleft: CornerBottomLeftIcon,
  cornerbottomright: CornerBottomRightIcon,
  cornertopleft: CornerTopLeftIcon,
  cornertopright: CornerTopRightIcon,
  fontsize: FontSizeIcon,
  lineheight: LineHeightIcon,
  bgpostopleft: BgPosTopLeftIcon,
  bgpostopcenter: BgPosTopCenterIcon,
  bgpostopright: BgPosTopRightIcon,
  bgposcenterleft: BgPosCenterLeftIcon,
  bgposcentercenter: BgPosCenterCenterIcon,
  bgposcenterright: BgPosCenterRightIcon,
  bgposbottomleft: BgPosBottomLeftIcon,
  bgposbottomcenter: BgPosBottomCenterIcon,
  bgposbottomright: BgPosBottomRightIcon,
  repeath: RepeatH,
  repeatv: RepeatV,
  repeatnone: RepeatNone,
  repeatvh: RepeatVH,
  previewview: PreviewViewIcon,
  floatleft: FloatLeftIcon,
  floatright: FloatRightIcon,
  clearleft: ClearLeftIcon,
  clearright: ClearRightIcon,
  clearboth: ClearBothIcon,
  filedoc: FileDocIcon,
  vector: VectorIcon,
  height: HeightIcon,
  width: WidthIcon,
  texttransformcapitalize: TextTransformCapitalizeIcon,
  texttransformlowercase: TextTransformLowercaseIcon,
  texttransformuppercase: TextTransformUppercaseIcon,

  // VKUI
  appfolder: AppFolderIcon,
  apps: AppsIcon,
  assigmentind: AssigmentIndIcon,
  boxup: BoxUpIcon,
  business: BusinessIcon,
  cloud: CloudIcon,
  contentcopy: ContentCopyIcon,
  delete: DeleteIcon,
  download: DownloadIcon,
  fileupload: FileUploadIcon,
  vkuifolder: VKUIFolderIcon,
  gppbad: GppBadIcon,
  gridview: GridViewIcon,
  groups: GroupsIcon,
  help: HelpIcon,
  history: HistoryIcon,
  howtoreg: HowToRegIcon,
  icemail: IcEmailIcon,
  info: InfoIcon,
  list: ListIcon,
  lock: LockIcon,
  login: LoginIcon,
  logout: LogoutIcon,
  modeedit: ModeEditIcon,
  notifications: NotificationsIcon,
  openwith: OpenWithIcon,
  people: PeopleIcon,
  person: PersonIcon,
  personadd: PersonAddIcon,
  phoneiphone: PhoneIphoneIcon,
  search: SearchIcon,
  staroutline: StarOutlineIcon,
  storage: StorageIcon,
  store: StoreIcon,
  tune: TuneIcon,
  visibility: VisibilityIcon,
  visibilityoff: VisibilityOffIcon,
  vpnkey: VpnKeyIcon,
  warning: WarningIcon,
  watchlater: WatchLaterIcon,
  done: DoneIcon,
  image: ImageIcon,
  link: LinkIcon,
  lockopen: LockOpenIcon,
}

export const iconKeys = Object.keys(
  robotenIcons
) as (keyof typeof robotenIcons)[]

export interface IRobotenIcon {
  /** Screen reader text for the visually impaired and bots.
   *
   */
  alt?: string

  /** The color of the component.
   *
   * @default "inherit"
   */
  color?: string

  /** The icon to display.
   *
   * @default "application"
   */
  iconName?: string

  /** The size of the icon in pixels.
   *
   * @default 24
   */
  size?: NamedSize | number

  /** *Deprecated* Raw CSS styles
   * @deprecated
   */
  styles?: CssStyles<'root'>

  style?: CSSProperties | string

  materialFallback?: boolean
}

export const RobotenIcon: React.FC<IRobotenIcon> = React.forwardRef<
  HTMLSpanElement,
  IRobotenIcon
>(
  (
    {
      alt,
      color = 'inherit',
      iconName = 'application',
      size = 24,
      style,
      styles,
      materialFallback = true,
    }: IRobotenIcon,
    ref
  ) => {
    const classNames = styles && parseClassNames(styles)
    const fixedName = iconName.toLocaleLowerCase()
    const Icon = robotenIcons[fixedName as keyof typeof robotenIcons]

    if (!Icon) {
      if (materialFallback) {
        return (
          <MaterialIcon
            ref={ref}
            alt={alt}
            color={color}
            iconName={iconName as IconName}
            size={size}
            style={style}
          />
        )
      } else {
        console.error(`Could not find icon "${iconName}".`)
        return <UnavailableIcon />
      }
    }

    // Cannot be set as width={undefined}
    const numericalSize = namedSizeToNumber(size)
    const sizes = numericalSize
      ? { width: numericalSize, height: numericalSize }
      : {}

    return (
      <RobotenIconWrapper ref={ref} size={numericalSize}>
        <Icon
          className={cx(classNames?.root, getClassName(style))}
          {...sizes}
        />
      </RobotenIconWrapper>
    )
  }
)

RobotenIcon.displayName = 'RobotenIcon'
